<div id="iqac-formation" class="inner-page">
    <div class="container-fluid px-lg-5">
        <h2 class="title">Formation of IQAC</h2>
        <!-- <p class="inner-lead mt-3">
      The Internal Quality Assurance Cell (IQAC) of Shah Satnam Ji Girls' College, Sirsa is constituted in accordance
      with NAAC guidelines. It serves as a facilitative and participative organ of the institution, planning, guiding,
      and monitoring quality enhancement and quality sustenance measures.
    </p> -->
        <hr class="divider">

        <div class="pdf-block">
            <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false"
                style="width: 100%; height: 680px; display: block;"></pdf-viewer>
        </div>

        <div class="mt-4 d-flex flex-wrap gap-3 justify-content-center">
            <a [href]="pdfSrc" target="_blank" class="pdf-download-btn">
                <i class="fa fa-download me-2"></i> Download Formation of IQAC PDF
            </a>
        </div>
    </div>
</div>